(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var SEL = '.sk-section__head, .sk-card, .sk-step, .sk-plan, .sk-faq details, .sk-cta';
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function initReveal(scope){
    if(reduce || design || !io) return;
    scope.querySelectorAll(SEL).forEach(function(el){
      if(el.classList.contains('sk-reveal')) return;
      var sibs = Array.prototype.filter.call(el.parentNode.children, function(c){ return c.matches(SEL); });
      el.style.setProperty('--sk-delay', Math.min(sibs.indexOf(el), 6) * 90 + 'ms');
      el.classList.add('sk-reveal');
      io.observe(el);
    });
  }

  function initGlow(scope){
    scope.querySelectorAll('.sk-card, .sk-plan, .sk-step').forEach(function(el){
      if(el.dataset.skGlow) return;
      el.dataset.skGlow = '1';
      el.addEventListener('pointermove', function(e){
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        el.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  function init(scope){ initReveal(scope); initGlow(scope); }
  init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });

  var header = document.querySelector('.sk-header');
  if(header){
    var on = false;
    var onScroll = function(){
      var s = window.scrollY > 12;
      if(s !== on){ on = s; header.classList.toggle('is-scrolled', s); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();